var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.1 36",
    style: {
      enableBackground: "new 0 0 38.1 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallet_00000128485843917529486960000015344603828101853096_",
    gradientUnits: "userSpaceOnUse",
    x1: -505.8536,
    y1: 544.5278,
    x2: -505.8536,
    y2: 543.5278,
    gradientTransform: "matrix(38.1053 0 0 -36 19294.752 19603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0071BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A043C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "wallet",
    style: {
      fill: "url(#wallet_00000128485843917529486960000015344603828101853096_)"
    },
    d: "M26.6,21.2 c0.8,0,1.6-0.4,2.2-1c0.6-0.6,1-1.4,1-2.3c0-0.8-0.4-1.6-1-2.2c-1.2-1.2-3.1-1.3-4.4-0.1c0,0-0.1,0.1-0.1,0.1c-0.6,0.6-1,1.4-1,2.2 c0,0.9,0.4,1.7,1,2.3C25,20.8,25.8,21.2,26.6,21.2z M3,30.3L3,30.3z M3,36c-0.8,0-1.5-0.3-2.1-0.9C0.3,34.6,0,33.8,0,33V3 c0-0.8,0.3-1.5,0.9-2.1C1.5,0.3,2.2,0,3,0h30c0.8,0,1.6,0.3,2.1,0.9C35.7,1.5,36,2.2,36,3v6.7h-3V3H3v30h30v-6.7h3V33 c0,1.6-1.4,3-3,3H3z M20.9,27.3c-1,0.1-2-0.3-2.7-1c-0.7-0.7-1-1.7-1-2.6V12.4c-0.1-1,0.3-2,1-2.7c0.7-0.7,1.7-1,2.7-1h13.5 c1-0.1,2,0.3,2.7,1c0.7,0.7,1.1,1.7,1,2.7v11.4c0,1-0.3,1.9-1,2.7c-0.7,0.7-1.7,1.1-2.7,1L20.9,27.3z M35.1,24.3V11.7H20.2v12.6 L35.1,24.3z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPurple);
export default __webpack_public_path__ + "static/media/wallet_purple.f00a1675894be7d9fb60214782254095.svg";
export { ForwardRef as ReactComponent };